/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseSetStatusResult {
  Error = 0,
  Success = 1,
  ValidationError = 2,
  CaseNotFound = 3,
  InvalidUser = 4,
  InvalidStatus = 5,
}
